<script>
    import MultipleSelector from '@/components/Form/MultipleSelector.vue'

    export default {
        name : 'device-family-selector',
        extends: MultipleSelector,
        created () {
            this.options = ['mobile', 'tablet', 'desktop', 'tv', 'game_console'];
        }
    }
</script>